/*
  Coltesse custom — parallaxe du contenu des bannières (repli).

  La voie normale est 100 % CSS : `animation-timeline: view()`, calculée par le
  compositeur du navigateur, sans le moindre écouteur de scroll. Ce fichier ne
  sert QUE aux navigateurs qui ne gèrent pas encore les animations pilotées par
  le défilement — Safari au premier chef, donc l'essentiel du trafic iPhone.

  Sur un navigateur qui gère (Chrome, Edge), le script sort à la 3ᵉ ligne :
  aucun écouteur posé, aucune mesure, coût nul. C'est la raison pour laquelle
  il ne pénalise pas les visiteurs qui ont déjà l'effet en CSS.

  ⚠️ Piège mesuré le 2026-08-30 : un ancêtre en `overflow: hidden` (le wrapper
  `.shopify-section` du thème) est un conteneur de défilement, et `view()` s'y
  cale au lieu de la page → l'animation reste figée à 0. Les sections passent
  donc ce wrapper en `overflow: clip`, qui découpe pareil sans être un
  conteneur de défilement. Ce repli JS, lui, n'est pas concerné.
*/
(function () {
  'use strict';

  if (window.__ccParallaxOverlay) { return; }
  window.__ccParallaxOverlay = true;

  // Le navigateur sait le faire en CSS : on ne pose rien.
  if (window.CSS && CSS.supports && CSS.supports('animation-timeline', 'view()')) { return; }

  // Accessibilité : le visiteur a demandé à réduire les animations.
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) { return; }

  var cibles = [];
  var enAttente = false;

  function recenser() {
    cibles = [];
    var noeuds = document.querySelectorAll('.cc-parallax[data-cc-parallax]');
    for (var i = 0; i < noeuds.length; i++) {
      var amplitude = parseFloat(noeuds[i].getAttribute('data-cc-parallax'));
      if (amplitude > 0) {
        cibles.push({ el: noeuds[i], amplitude: amplitude, pose: 0 });
      }
    }
  }

  function placer() {
    enAttente = false;
    var hauteurVue = window.innerHeight || document.documentElement.clientHeight;

    for (var i = 0; i < cibles.length; i++) {
      var c = cibles[i];
      var boite = c.el.getBoundingClientRect();

      // La boîte inclut le décalage déjà appliqué : on le retire pour ne pas
      // mesurer notre propre effet et partir en boucle.
      var haut = boite.top - c.pose;

      // Même progression que `animation-range: entry 0% exit 100%` :
      // 0 quand l'élément entre par le bas, 1 quand il est sorti par le haut.
      var avance = (hauteurVue - haut) / (hauteurVue + boite.height);
      if (avance < 0) { avance = 0; } else if (avance > 1) { avance = 1; }

      var decalage = c.amplitude - avance * c.amplitude * 2;
      if (decalage !== c.pose) {
        c.pose = decalage;
        c.el.style.transform = 'translate3d(0,' + decalage.toFixed(2) + 'px,0)';
      }
    }
  }

  function demander() {
    if (enAttente) { return; }
    enAttente = true;
    window.requestAnimationFrame(placer);
  }

  function demarrer() {
    recenser();
    if (!cibles.length) { return; }
    placer();
    window.addEventListener('scroll', demander, { passive: true });
    window.addEventListener('resize', demander);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', demarrer);
  } else {
    demarrer();
  }

  // L'éditeur de thème recharge une section sans recharger la page.
  document.addEventListener('shopify:section:load', function () {
    recenser();
    placer();
  });
})();
